export enum TimeRecordActivity {
  Rest = 0,
  Meal = 1,
  Working = 2,
}
